import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../../components/ui/button';

export const WizardNavigationButtons = ({
  currentStep,
  totalSteps,
  submitting,
  submissionCompleted,
  language,
  tr,
  onBack,
  onNext,
}) => {
  const isFinalStep = currentStep === totalSteps;

  const nextLabel = submitting
    ? (language === 'es' ? 'Enviando…' : 'Submitting…')
    : submissionCompleted
      ? tr('wizard.readonly.viewRecommendation')
      : isFinalStep
        ? tr('wizard.viewRecommendation')
        : tr('wizard.continue');

  return (
    <div className="flex justify-between mt-8 pt-6 border-t border-gray-200">
      {currentStep > 1 ? (
        <Button
          variant="outline"
          onClick={onBack}
          className="border-gray-300 hover:border-blue-900 hover:text-blue-900"
          data-testid="wizard-back-btn"
        >
          <ChevronLeft className="w-4 h-4 mr-2" />
          {tr('wizard.back')}
        </Button>
      ) : (
        <div></div>
      )}

      <Button
        onClick={onNext}
        disabled={submitting}
        className="bg-blue-900 hover:bg-blue-800 text-white disabled:opacity-60"
        data-testid="wizard-continue-btn"
      >
        {nextLabel}
        {!submitting && !submissionCompleted && !isFinalStep && <ChevronRight className="w-4 h-4 ml-2" />}
      </Button>
    </div>
  );
};
